// src/components/ConfirmationDialog.tsx

import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import CustomButton from '../Button/DialogButtons';


interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth sx={{ borderRadius: 8 }}>
      <DialogContent sx={{ paddingY: 3, borderRadius: 8 }}>
        <div className="text-center">
          <DialogContentText
            sx={{ color: 'black', fontFamily: 'Jost, sans-serif', textAlign: 'center', fontSize: '1.25rem' }}
          >
            Are you sure you want to delete?
        </DialogContentText>
        </div>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
        <CustomButton onClick={onConfirm} color="primary">
          Yes
        </CustomButton>
        <CustomButton onClick={onClose} color="secondary">
          No
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
